import { Map as map } from 'immutable';
const C = require("../constants");

function ExpenseSelectReducer(state = map(), action) {
    switch (action.type) {
        case C.EXPENSE_SELECT:
            return action.data;
        default:
            return state;
    }
};

export default ExpenseSelectReducer;


// WEBPACK FOOTER //
// ./src/reducers/ExpenseSelectReducer.js